import React, { useState, useEffect } from 'react';
import { getAllSalesPersons } from '../services/ApiWorkflow';
import { stageLayoutStyles, stageFormStyles } from '../components/createworkflow/helper';
import PageHeader from '../components/common/PageHeader';
import { displayMessage } from '../Utils/helper';

const pageStyles = {
  wrapper: {
    width: '100%',
    boxSizing: 'border-box',
    background: '#f4f3ef',
  },
  card: {
    ...stageLayoutStyles.card,
    marginBottom: 14,
  },
  cardTitle: {
    ...stageFormStyles.sectionTitle,
    marginBottom: 12,
    paddingBottom: 10,
    borderBottom: '1px solid #e6eef4',
  },
  formRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 14,
    alignItems: 'flex-end',
  },
  formField: {
    flex: '1 1 220px',
    minWidth: 0,
  },
  primaryBtn: {
    padding: '8px 18px',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'Poppins, sans-serif',
    color: '#fff',
    background: '#E06639',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    boxShadow: '0 3px 10px rgba(224, 102, 57, 0.25)',
    transition: 'background 0.15s ease',
    whiteSpace: 'nowrap',
  },
  primaryBtnDisabled: {
    background: '#9ca3af',
    cursor: 'not-allowed',
    boxShadow: 'none',
  },
  secondaryBtn: {
    display: 'inline-block',
    padding: '7px 14px',
    fontSize: 12,
    fontWeight: 700,
    fontFamily: 'Poppins, sans-serif',
    color: '#fff',
    background: '#c9552a',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(201, 85, 42, 0.28)',
    whiteSpace: 'nowrap',
    lineHeight: 1.2,
    transition: 'background 0.15s ease, box-shadow 0.15s ease',
  },
  tableWrap: {
    width: '100%',
    overflowX: 'auto',
    borderRadius: 12,
    border: '1px solid #e6eef4',
    boxShadow: '0 3px 12px rgba(12, 60, 84, 0.06)',
    background: '#fff',
  },
  table: {
    width: '100%',
    minWidth: 640,
    borderCollapse: 'collapse',
    fontFamily: 'Poppins, sans-serif',
  },
  th: {
    background: '#032B4E',
    color: '#fff',
    padding: '12px 16px',
    fontSize: 13,
    fontWeight: 700,
    textAlign: 'center',
    borderRight: '1px solid rgba(255,255,255,0.1)',
    whiteSpace: 'nowrap',
  },
  thLast: {
    background: '#032B4E',
    color: '#fff',
    padding: '12px 16px',
    fontSize: 13,
    fontWeight: 700,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '12px 16px',
    fontSize: 13,
    fontWeight: 500,
    color: '#0c3c54',
    borderBottom: '1px solid #e6eef4',
    borderRight: '1px solid #e6eef4',
    verticalAlign: 'middle',
    textAlign: 'left',
  },
  tdEmail: {
    padding: '12px 16px',
    fontSize: 13,
    fontWeight: 500,
    color: '#6a7d8c',
    borderBottom: '1px solid #e6eef4',
    borderRight: '1px solid #e6eef4',
    verticalAlign: 'middle',
    textAlign: 'left',
  },
  tdCenter: {
    padding: '12px 16px',
    fontSize: 13,
    color: '#0c3c54',
    borderBottom: '1px solid #e6eef4',
    textAlign: 'center',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
  rowActive: {
    background: '#f8fbfd',
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #021a30 0%, #032B4E 100%)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 600,
    flexShrink: 0,
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  nameText: {
    fontSize: 13,
    fontWeight: 600,
    color: '#0c3c54',
    fontFamily: 'Poppins, sans-serif',
  },
  expandCell: {
    padding: 0,
    background: '#f8fbfd',
    borderBottom: '1px solid #e6eef4',
  },
  foldPanel: {
    padding: '10px 14px 12px',
  },
  foldTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: '#0c3c54',
    margin: '0 0 8px 0',
    textAlign: 'left',
    fontFamily: 'Poppins, sans-serif',
  },
  innerTableWrap: {
    width: '100%',
    overflowX: 'auto',
    borderRadius: 8,
    border: '1px solid #e6eef4',
    background: '#fff',
  },
  innerTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 12,
    fontFamily: 'Poppins, sans-serif',
  },
  innerTh: {
    background: '#f8fafc',
    color: '#0c3c54',
    padding: '8px 10px',
    fontWeight: 700,
    fontSize: 13,
    borderBottom: '1px solid #e6eef4',
    borderRight: '1px solid #e6eef4',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  innerThLast: {
    background: '#f8fafc',
    color: '#0c3c54',
    padding: '8px 10px',
    fontWeight: 700,
    fontSize: 13,
    borderBottom: '1px solid #e6eef4',
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  innerTd: {
    padding: '5px 10px',
    borderBottom: '1px solid #e6eef4',
    borderRight: '1px solid #e6eef4',
    color: '#6a7d8c',
    fontWeight: 500,
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  innerTdLast: {
    padding: '5px 10px',
    borderBottom: '1px solid #e6eef4',
    color: '#0c3c54',
    fontWeight: 500,
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  tag: {
    display: 'inline-block',
    background: '#eff7fc',
    color: '#032B4E',
    padding: '2px 8px',
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 600,
    border: '1px solid #c4e0f0',
  },
  emptyText: {
    textAlign: 'center',
    padding: '32px 16px',
    fontSize: 13,
    color: '#6a7d8c',
    fontFamily: 'Poppins, sans-serif',
  },
};

export default function SalesPersonPage() {
  const [salesPersonsList, setSalesPersonsList] = useState([]);
  const [skuMap, setSkuMap] = useState({});
  const [form, setForm] = useState({ sp_name: '', sp_email: '' });
  const [loading, setLoading] = useState(false);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    fetchSalesPersons();
  }, []);

  const fetchSalesPersons = async () => {
    const data = await getAllSalesPersons();
    setSalesPersonsList(data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddSalesPerson = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/add_sp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const result = await response.json();
      if (result.status === 'success') {
        displayMessage('success', 'Success', 'Salesperson added successfully!');
        setForm({ sp_name: '', sp_email: '' });
        fetchSalesPersons();
      } else {
        displayMessage('danger', 'Error', result.message || 'Failed to add salesperson.');
      }
    } catch (err) {
      console.error(err);
      displayMessage('danger', 'Error', 'Error adding salesperson.');
    } finally {
      setLoading(false);
    }
  };

  const handleSKUClick = async (sp_id) => {
    if (!skuMap[sp_id]) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/get_sp_sku_mapping?sp_id=${sp_id}`);
        const result = await response.json();
        if (result.Status === 'success') {
          setSkuMap((prev) => ({
            ...prev,
            [sp_id]: result.data?.filter((el) => el.sku_level1 !== null),
          }));
        }
      } catch (error) {
        console.error('Error fetching SKU mapping:', error);
      }
    }
    setExpandedId((prev) => (prev === sp_id ? null : sp_id));
  };

  return (
    <div className="sales-team-page" style={pageStyles.wrapper}>
      <style>{salesTeamPageStyles}</style>
      <PageHeader
        title="Sales Team"
        subtitle="View and manage salespersons and their assigned SKUs."
      />

      <div style={pageStyles.card}>
        <h2 style={pageStyles.cardTitle}>Add New Salesperson</h2>
        <form onSubmit={handleAddSalesPerson}>
          <div style={pageStyles.formRow}>
            <div style={pageStyles.formField}>
              <label style={stageFormStyles.label}>Name</label>
              <input
                type="text"
                name="sp_name"
                placeholder="Enter salesperson name"
                value={form.sp_name}
                onChange={handleChange}
                required
                style={stageFormStyles.input}
              />
            </div>
            <div style={pageStyles.formField}>
              <label style={stageFormStyles.label}>Email</label>
              <input
                type="email"
                name="sp_email"
                placeholder="Enter email address"
                value={form.sp_email}
                onChange={handleChange}
                required
                style={stageFormStyles.input}
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              style={{
                ...pageStyles.primaryBtn,
                ...(loading ? pageStyles.primaryBtnDisabled : {}),
              }}
            >
              {loading ? 'Adding...' : 'Add Salesperson'}
            </button>
          </div>
        </form>
      </div>

      <div style={pageStyles.card}>
        <h2 style={pageStyles.cardTitle}>Sales Team Directory</h2>
        <div style={pageStyles.tableWrap}>
          <table style={pageStyles.table}>
            <thead>
              <tr>
                <th style={pageStyles.th}>Name</th>
                <th style={pageStyles.th}>Email</th>
                <th style={pageStyles.thLast}>Assigned SKUs</th>
              </tr>
            </thead>
            <tbody>
              {salesPersonsList.length > 0 ? (
                salesPersonsList.map((elem) => (
                  <React.Fragment key={elem.sp_id}>
                    <tr style={expandedId === elem.sp_id ? pageStyles.rowActive : undefined}>
                      <td style={pageStyles.td}>
                        <div style={pageStyles.nameCell}>
                          <div style={pageStyles.avatar}>
                            {elem.sp_name?.charAt(0)?.toUpperCase()}
                          </div>
                          <span style={pageStyles.nameText}>{elem.sp_name}</span>
                        </div>
                      </td>
                      <td style={pageStyles.tdEmail}>{elem.sp_email}</td>
                      <td style={pageStyles.tdCenter}>
                        <button
                          type="button"
                          onClick={() => handleSKUClick(elem.sp_id)}
                          style={pageStyles.secondaryBtn}
                        >
                          {expandedId === elem.sp_id ? 'Hide SKUs' : 'View SKUs'}
                        </button>
                      </td>
                    </tr>
                    {expandedId === elem.sp_id && (
                      <tr>
                        <td colSpan="3" style={pageStyles.expandCell}>
                          <div style={pageStyles.foldPanel}>
                            <h4 style={pageStyles.foldTitle}>
                              SKU Assignments for {elem.sp_name}
                            </h4>
                            {skuMap[elem.sp_id]?.length > 0 ? (
                              <div style={pageStyles.innerTableWrap}>
                                <table style={pageStyles.innerTable}>
                                  <thead>
                                    <tr>
                                      <th style={pageStyles.innerTh}>Geography</th>
                                      <th style={pageStyles.innerThLast}>SKU Brand / Category</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {skuMap[elem.sp_id].map((item, skuIndex) => (
                                      <tr key={skuIndex}>
                                        <td style={pageStyles.innerTd}>{item.geo_location}</td>
                                        <td style={pageStyles.innerTdLast}>
                                          <span style={pageStyles.tag}>
                                            {item.sku_level1} \ {item.sku_level2}
                                          </span>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : (
                              <p style={{ ...pageStyles.emptyText, padding: '12px 0' }}>
                                No SKU assignments found
                              </p>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={pageStyles.emptyText}>
                    No salespersons found. Add your first salesperson above.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const salesTeamPageStyles = `
  .sales-team-page label {
    font-family: Poppins, sans-serif !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    color: #0c3c54 !important;
    margin-bottom: 8px !important;
    text-transform: none !important;
  }

  .sales-team-page input {
    font-family: Poppins, sans-serif !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #0c3c54 !important;
  }

  .sales-team-page input::placeholder {
    font-family: Poppins, sans-serif !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    color: #6a7d8c !important;
  }
`;
